/**
 * Paths of the old postolarvarga.hr shop that Google still crawls (Search
 * Console 404 and 5xx reports, September 2026), mapped to their current page
 * without the locale. Products that no longer exist point to their collection.
 */
export const LEGACY_REDIRECTS: Partial<Record<string, string>> = {
  "/anatomska-papuca-hap-002": "/product/honopono-044",
  "/anatomska-papuca-hap-004": "/product/honopono-121",
  "/anatomska-papuca-hap-005": "/product/honopono-108",
  "/anatomska-papuca-hap-007": "/product/papuce-kozne-sive-ruzicasti-detalji",
  "/anatomska-papuca-hap-009": "/product/honopono-018",
  "/anatomska-papuca-hap-011": "/product/honopono-021",
  "/anatomska-papuca-hap-016": "/product/honopono-130",
  "/anatomska-papuca-hap-018": "/product/honopono-050",
  "/anatomska-papuca-hap-019": "/product/honopono-054",
  "/anatomska-papuca-hap-021": "/product/honopono-059",
  "/anatomska-papuca-hap-022": "/product/honopono-060",
  "/anatomska-papuca-hap-024": "/product/honopono-073",
  "/anatomska-papuca-hap-030": "/product/honopono-124",
  "/anatomska-papuca-hap-032": "/product/honopono-106",
  "/anatomska-papuca-hap-036": "/product/honopono-164",
  "/anatomska-papuca-hap-038": "/product/honopono-085",
  "/anatomska-papuca-hap-044": "/product/honopono-158",
  "/anatomska-papuca-hap-046": "/product/honopono-100",
  "/anatomska-papuca-hap-049": "/product/honopono-081",
  "/anatomska-papuca-hap-050": "/product/honopono-082",
  "/anatomska-papuca-hap-051": "/product/honopono-083",
  "/anatomska-papuca-hap-052": "/product/honopono-093",
  "/anatomska-papuca-hap-053": "/product/honopono-176",
  "/anatomska-papuca-hap-055": "/product/honopono-120",
  "/anatomska-papuca-hap-056": "/product/honopono-066",
  "/anatomska-papuca-hap-059": "/product/honopono-155",
  "/anatomska-papuca-hap-060": "/product/honopono-153",
  "/anatomska-papuca-hap-064": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-066": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-068": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-069": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-071": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-072": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-073": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-074": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-078": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-080": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-084": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-086": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-090": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-092": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-093": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-094": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-096": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-097": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-100": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-101": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-104": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-105": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-112": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-113": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-114": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-115": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-116": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-118": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-120": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-122": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-124": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-128": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-132": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-134": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-137": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-141": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-143": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-147": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-148": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-151": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-153": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-156": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-161": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-164": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-165": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-167": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-168": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-175": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-176": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-177": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-178": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-180": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-182": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap-lj001": "/product/hap-lj001",
  "/anatomska-papuca-hap-lj002": "/product/hap-lj002",
  "/anatomska-papuca-hap-lj007": "/product/hap-lj007",
  "/anatomska-papuca-hap-lj008": "/product/5",
  "/anatomska-papuca-hap-lj010": "/product/sandale-ljetne-crne-plazne",
  "/anatomska-papuca-hap-lj013": "/product/sandale-zenske-crne-crveni-remen",
  "/anatomska-papuca-hap-lj014": "/product/sandale-zenske-crveni-remen",
  "/anatomska-papuca-hap-lj017": "/product/sandale-ljetne-lagani-potplat",
  "/anatomska-papuca-hap-lj021": "/product/ljetne-kozne-sandale-meki-ulozak",
  "/anatomska-papuca-hap-lj022": "/product/ljetne-kozne-sandale-crni-remen",
  "/anatomska-papuca-hap-lj023": "/product/ljetne-kozne-sandale-kopcom",
  "/anatomska-papuca-hap-lj027": "/product/natikace-bijele-zeleno-plavi-remeni",
  "/anatomska-papuca-hap-lj028": "/product/natikace-crne-ruzicastim-remenom",
  "/anatomska-papuca-hap-lj041": "/collections/otvorene-anatomske-papuce",
  "/anatomska-papuca-hap-lj042": "/collections/otvorene-anatomske-papuce",
  "/anatomska-papuca-hap-lj044": "/collections/otvorene-anatomske-papuce",
  "/anatomska-papuca-hap-lj046": "/collections/otvorene-anatomske-papuce",
  "/anatomska-papuca-hap-lj050": "/collections/otvorene-anatomske-papuce",
  "/anatomska-papuca-hap-lj053": "/collections/otvorene-anatomske-papuce",
  "/anatomska-papuca-hap-lj055": "/collections/otvorene-anatomske-papuce",
  "/anatomska-papuca-hap-lj056": "/collections/otvorene-anatomske-papuce",
  "/anatomska-papuca-hap-m003": "/product/papuce-svijetlo-sive",
  "/anatomska-papuca-hap-m004": "/product/natikace-crne-dvije-kopce",
  "/anatomska-papuca-hap184": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap188": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap189": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap191": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap195": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap196": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap197": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap198": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap199": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap201": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap202": "/collections/novi-proizvodi",
  "/anatomska-papuca-hap203": "/collections/novi-proizvodi",
  "/anatomska-sandala-hap-s003": "/product/sandale-bez-leopard",
  "/anatomska-sandala-hap-s004": "/product/hap-s004",
  "/anatomska-sandala-hap-s005": "/product/hap-s005",
  "/anatomska-sandala-hap-s006": "/product/hap-s006",
  "/anatomska-sandala-hap-s009": "/product/hap-s009",
  "/anatomska-sandala-hap-s010": "/product/hap-s010",
  "/anatomska-sandala-hap-s012": "/product/hap-s012",
  "/anatomske-papuce/anatomska-papuca-hap-008": "/product/honopono-131",
  "/anatomske-papuce/anatomska-papuca-hap-010": "/product/honopono-010",
  "/blog": "/blog",
  "/dostava": "/info/ordering-and-delivery",
  "/futrola-za-naocale-kozna-kf001": "/collections/kozna-galanterija",
  "/honopono": "",
  "/index.php": "/products",
  "/kozna-torbica-crna-mala-kt006": "/collections/torbe",
  "/kozni-ruksak-crni-kr002": "/collections/torbe",
  "/o-nama": "/info/about-us",
  "/obrasci/obrazac-za-jednostrani-raskid-ugovora.doc": "/info/withdrawal-form",
  "/obrasci/obrazac-za-jednostrani-raskid-ugovora.pdf": "/info/withdrawal-form",
  "/obrasci/pisani-prigovor-potrosaca.doc": "/info/contact-information",
  "/ogrlice-i-povodci-za-pse": "/collections/kozne-ogrlice-i-povodci-za-pse",
  "/ogrlice-i-povodci-za-pse/kozna-ogrlica-i-povodac-kop001":
    "/collections/kozne-ogrlice-i-povodci-za-pse",
  "/poklon-bonovi": "/products",
  "/povrat": "/info/return-policy",
  "/remen-kozni-crni": "/product/kozni-remen-crni",
  "/remen-kozni-crni-z001": "/product/kozni-remen-z-001",
  "/remen-kozni-pleteni-z006": "/collections/remenje",
  "/remen-kozni-pleteni-z007": "/collections/remenje",
  "/remen-kozni-pleteni-z008": "/collections/remenje",
  "/remen-kozni-pleteni-z009": "/collections/remenje",
  "/remen-kozni-pleteni-z010": "/collections/remenje",
  "/remen-kozni-pleteni-z015": "/collections/remenje",
  "/remen-kozni-pleteni-z016": "/collections/remenje",
  "/remen-kozni-pleteni-z019": "/collections/remenje",
  "/remen-kozni-pleteni-z024": "/product/kozni-remen-z-024",
  "/remen-kozni-pleteni-z025": "/product/kozni-remen-z-025",
  "/remen-kozni-smedji": "/product/kozni-remen-smedji",
  "/remen-kozni-smedji-kopca-001": "/collections/remenje",
  "/remenje/remen-kozni-crni-z002": "/product/kozni-remen-z-002",
  "/torba-kozna-crna-kt001": "/collections/torbe",
  "/torba-kozna-smedja-mala-kt003": "/collections/torbe",
  "/torbe": "/collections/torbe",
  "/torbe/torbica-kozna-smedja-mala-kt004": "/collections/torbe",
  "/vargice-pro-002": "/collections/vargice-pro",
  "/vargice-pro-003": "/collections/vargice-pro",
  "/vargice-pro-004": "/collections/vargice-pro",
  "/vargice-pro-006": "/collections/vargice-pro",
  "/vargice-pro-007": "/collections/vargice-pro",
  "/vargice-pro-008": "/collections/vargice-pro",
  "/vargice-pro-009": "/collections/vargice-pro",
  "/vargice-pro-010": "/collections/vargice-pro",
  "/vargice-pro/vargice-pro-001": "/collections/vargice-pro",
  "/vargice-pro/vargice-pro-003": "/collections/vargice-pro",
};
